"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var event_1 = require("./event");
var ErrorCreated = /** @class */ (function (_super) {
    __extends(ErrorCreated, _super);
    function ErrorCreated() {
        return _super.call(this, "errorCreated", {
            code: "",
            description: ""
        }) || this;
    }
    ErrorCreated.prototype.GetCode = function () {
        return this.getEventBody().getJson().code;
    };
    ;
    ErrorCreated.prototype.SetCode = function (code) {
        this.getEventBody().getJson().code = code;
        return this;
    };
    ;
    ErrorCreated.prototype.GetDescription = function () {
        return this.getEventBody().getJson().description;
    };
    ;
    ErrorCreated.prototype.SetDescription = function (description) {
        this.getEventBody().getJson().description = description;
        return this;
    };
    ;
    ErrorCreated.prototype._isPrefab = function () {
        return true;
    };
    return ErrorCreated;
}(event_1.default));
exports.default = ErrorCreated;
//# sourceMappingURL=errorCreated.js.map